<!-- 综合展示 -->
<template>
  <div id="app">
    <div id="map" class="map">
      <!-- 新加载组件 -->
      <component1 />
      <!--左侧树-->
      <!-- <AreaTreeCard
          ref="areaTreeCard"
          :area-loading="areaLoading"
          :area-tree="areaTree"
          :curr-selected="currSelected"
          @node-selected="handleNodeSelected"
          @node-unselected="handleNodeUnselected"
          @unselect="resetAareaData"
          @collapse-all="collapseTree"
          @area-add="handleAreaAdd"
          @add-child="handleAdd"
          @delete="handleDelete"
          @toggle-visibility="handleTreeToggle"
        /> -->
      <!-- 右侧详情 -->
      <AreaDetail v-show="areaDetailVisible" :area-info="areaInfo" :node-list="areaNodeList" :loading="detailLoading"
        @add-nodes="showNodeModal" @delete-node="handleDeleteNode" @close="handleCloseAreaDetail" />
      <!-- 右下角控制信息容器 -->
      <div class="map-controls-container">
        <!-- 缩放级别显示 -->
        <div class="zoom-level-display">{{ $t('缩放级别') }}: {{ zoomLevel }}</div>

        <!-- 比例尺容器 -->
        <div id="scale-line-container" class="scale-line-custom-container"></div>
        <!-- 坐标显示（可点击切换） -->
        <div class="coordinate-display" @click="toggleCoordinateProjection">
          X: {{ formattedCoordinate.x }} Y: {{ formattedCoordinate.y }}
        </div>
      </div>
      <!--    详情弹窗-->
      <div id="popup" v-show="visible">
        <div class="popup-header">
          <span>{{ $t('详情') }}</span>
          <a-icon type="close" @click="closePopup" />
        </div>
        <a-list bordered class="popup-list">
          <a-list-item> {{ $t('项目编码') }}:{{ clickCurrentRow.projectCode || clickCurrentRow.project_code }} </a-list-item>
          <a-list-item v-if="clickCurrentRow.topology_code || clickCurrentRow.topologyCode">
            {{ $t('拓扑编码') }}:{{ clickCurrentRow.topologyCode || clickCurrentRow.topology_code }}
          </a-list-item>
          <a-list-item> {{ $t('编码') }}:{{ clickCurrentRow.code }} </a-list-item>
          <a-list-item> {{ $t('名称') }}:{{ clickCurrentRow.name }} </a-list-item>
          <a-list-item v-if="clickCurrentRow.type == 'NODE_PIPELINE_TYPE_PIPELINE'"> {{ $t('类型') }}: {{ $t('管线') }}</a-list-item>
          <a-list-item v-else-if="clickCurrentRow.type">
            {{ $t('类型') }}:{{ filterDictTextByCache('node_type', clickCurrentRow.type) }}
          </a-list-item>
          <a-list-item v-if="clickCurrentRow.height >= 0"> {{ $t('高程') }}:{{ clickCurrentRow.height }} </a-list-item>
          <a-list-item v-if="clickCurrentRow.type == 'NODE_PIPELINE_TYPE_PIPELINE'">
            {{ $t('材质') }}:{{ clickCurrentRow.materialType }}
          </a-list-item>
          <!-- 物联数据分隔行 -->
          <a-list-item v-if="deviceData" class="popup-iot-divider">{{ $t('物联数据') }}</a-list-item>
          <template v-if="deviceData">
            <a-list-item> {{ $t('设备编号') }}: {{ deviceData.deviceId }} </a-list-item>
            <a-list-item> {{ $t('设备位置') }}: {{ deviceData.deviceLocation }} </a-list-item>
            <!-- 压力计 -->
            <template v-if="deviceData.deviceType === 'PM' && iotData">
              <a-list-item> {{ $t('压力') }}: {{ iotData.pvalue }} MPa </a-list-item>
              <a-list-item> {{ $t('温度') }}: {{ iotData.tepvalue }} ℃ </a-list-item>
              <a-list-item> {{ $t('电压') }}: {{ iotData.battery }} V </a-list-item>
              <a-list-item> {{ $t('信号') }}: {{ iotData.signDb }} dB </a-list-item>
              <a-list-item> {{ $t('上报时间') }}: {{ iotData.metertime }} </a-list-item>
            </template>
            <!-- 水表 -->
            <template v-else-if="deviceData.deviceType === 'METER' && iotData">
              <a-list-item> {{ $t('累计用量') }}: {{ iotData.meterDayUse }} </a-list-item>
              <a-list-item> {{ $t('上报时间') }}: {{ iotData.systime }} </a-list-item>
            </template>
          </template>
          <a-list-item v-else class="popup-iot-empty">{{ $t('未绑定物联设备') }}</a-list-item>
        </a-list>
        <!-- 物联设备数据 -->

      </div>
    </div>

    <!-- 新增节点弹窗 -->
    <j-modal :title="$t('选择节点')" :visible="nodeModalVisible" @ok="handleAddNodes" @cancel="nodeModalVisible = false"
      width="70%">
      <a-table :columns="nodeTableColumns" :data-source="allNodes" rowKey="id" :row-selection="{
        selectedRowKeys: selectedNodeKeys,
        onChange: handleNodeSelection,
      }" :pagination="pagination" @change="handleTableChange">
      </a-table>
    </j-modal>
    <!-- 新增分区 弹窗 -->
    <j-modal :title="addAreaType == 'addMain' ? $t('新增分区') : $t('新增子分区')" width="25%" :visible="visibleModal"
      :confirmLoading="confirmLoading" :maskClosable="false"
      :body-style="{ height: '380px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk" @cancel="handleCancel"
      :okText="$t('确定')" :cancelText="$t('关闭')">
      <a-spin :spinning="confirmLoading">
        <a-form-model ref="form" :model="model" :rules="validatorRules" :colon="true" layout="horizontal"
          :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('项目编码')">
                <a-input v-model="model.projectCode" disabled></a-input>
              </a-form-model-item>
            </a-col>
            <a-col v-if="addAreaType == 'addSub'" :span="24">
              <a-form-model-item :label="$t('父级名称')">
                <a-input v-model="currSelected.name" disabled></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('分区名称')" prop="name">
                <a-input v-model="model.name" :placeholder="$t('请输入项目名称')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注')"></a-textarea>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </j-modal>
  </div>
</template>

<script>
import Overlay from 'ol/Overlay.js'
import 'ol/ol.css'
import Map from 'ol/Map'
import View from 'ol/View'
import { get as getProjection, fromLonLat, toLonLat } from 'ol/proj'
import { createLayerEm_topology_node_pipeline } from '../PipelineNetMap/module/layers/Em_topology_node_pipeline.js'
import { createLayerEM_MAP_ALL_18 } from '../PipelineNetMap/module/layers/EM_MAP_ALL_18_DARK.js'
import { createLayerTp_node } from '../PipelineNetMap/module/layers/Tp_node.js'
import { createLayerTp_pipeline } from '../PipelineNetMap/module/layers/Tp_pipeline.js'
import { createLayerTp_area } from '../PipelineNetMap/module/layers/Tp_area.js'
import { createGetFeatureInfo } from '../PipelineNetMap/module/comFunction/WmsGetFeatureInfo.js'
import { parseHexWKB, zoomToPoint, zoomToLine } from '../PipelineNetMap/module/comFunction/ComFunction.js'
import { updateOrCreateGeoServerStyle } from '../PipelineNetMap/module/comFunction/SLDFunction.js'
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { vectorStyle } from '../PipelineNetMap/module/style/VectorStyle.js'
import { Feature } from 'ol'
import CONFIG from '../PipelineNetMap/module/config/GIS_Config'
import ScaleLine from 'ol/control/ScaleLine'
import {
  getPostGreSqlNodeInfoByCode,
  getPostGreSqlLineInfoByCode,
  getPostGreSqlAreaInfoByCode,
} from '../PipelineNetMap/module/comFunction/ApiFunction.js'
import AreaTreeCard from '../PipelineNetMap/components/AreaTreeCard.vue'
import AreaDetail from '../PipelineNetMap/components/AreaDetail.vue'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'

import { Circle, Fill, Stroke, Style, RegularShape } from 'ol/style' // Text as TextStyle 已随区域名称标注停用而移除
import { Draw, Modify, Snap } from 'ol/interaction'
// import GeoJSON from 'ol/format/GeoJSON' // 已随区域名称标注停用而注释
// import Point from 'ol/geom/Point' // 已随区域名称标注停用而注释
import { postAction, getAction, deleteAction } from '@/api/manage'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { mixinDevice } from '@/utils/mixin'
import component1 from './component1.vue'

export default {
  name: 'App',
  components: { AreaTreeCard, AreaDetail, component1 },
  mixins: [AreaChoosetMixin, JeecgListMixin, mixinDevice],
  data() {
    return {
      columns: [], // 修复 JeecgListMixin 中的 getQueryField 方法错误
      filterDictTextByCache: filterDictTextByCache,
      map: {},
      tileLayer: {},
      baseLayer: {},
      nodeLayerNode: {},
      pipeLineLayer: {},
      areaLayer: {},
      areaLabelLayer: {}, // 区域名称标注图层
      highlightLayer: {}, // 高亮矢量图层
      tileSource: {},
      view: {},
      resolutions: [],
      matrixIds: [],
      projection: '',
      clickCurrentRow: {
        project_code: '',
        topology_code: '',
        code: '',
        name: '',
        type: '',
      },
      iotData: null, // 物联实时数据
      deviceData: null, // 绑定设备信息
      visible: false,
      zoomLevel: 0, //
      topology: '', // 全局拓扑参数
      scaleDisplayInterval: null, // 比例尺更新定时器
      coordinateProjection: 'EPSG:3857', // 当前坐标系（3857或4326）
      currentCoordinate: null,
      model: {},
      visibleModal: false,
      disableSubmit: false,
      confirmLoading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      isAddOpen: false,
      addAreaType: 'addMain',
      mode: 'none',
      nodeVectorSource: new VectorSource(),
      pipeVectorSource: new VectorSource(),
      areaVectorSource: new VectorSource(),
      drawInteraction: null,
      modifyInteraction: null,
      url: {
        list: '/jeecg-gis/area/list',
        add: '/jeecg-gis/area/add',
        deleteArea: '/jeecg-gis/area/delete',
        queryAreaTree: '/jeecg-gis/area/queryAreaTree',
      },
      // 左边树
      collapsed: false,
      currSelected: {},
      areaTree: [], // 移动到此处作为数据源
      defaultProps: {
        children: 'areaList',
        label: 'name',
        value: 'code',
      },
      areaDetailVisible: false, // 控制详情组件显示
      areaInfo: {}, // 区域详细信息
      areaNodeList: [], // 区域节点列表
      allNodes: [], // 所有节点数据
      selectedNodeKeys: [], // 选中的节点keys
      nodeModalVisible: false, // 节点选择弹窗
      detailLoading: false, // 详情加载状态
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: total => this.$t('共{total}条', { total }),
      },
    }
  },
  computed: {
    validatorRules() {
      return {
        name: [{ required: true, message: this.$t('请输入分区名称') }],
      }
    },
    nodeTableColumns() {
      return [
        { title: this.$t('节点编码'), dataIndex: 'code' },
        { title: this.$t('节点名称'), dataIndex: 'name' },
        { title: this.$t('节点类型'), dataIndex: 'type', customRender: text => this.filterDictTextByCache('node_type', text) },
      ]
    },
    // 格式化坐标显示
    formattedCoordinate() {
      if (!this.currentCoordinate) {
        return { x: '--', y: '--' }
      }

      if (this.coordinateProjection === 'EPSG:3857') {
        // 3857坐标系显示，保留3位小数
        return {
          x: this.currentCoordinate.x.toFixed(3),
          y: this.currentCoordinate.y.toFixed(3),
        }
      } else {
        // 4326坐标系显示（经纬度），保留6位小数
        const lonLat = toLonLat([this.currentCoordinate.x, this.currentCoordinate.y])
        return {
          x: lonLat[0].toFixed(6),
          y: lonLat[1].toFixed(6),
        }
      }
    },
  },
  mounted() {
    // 确保DOM加载完了再初始化地图
    this.$nextTick(() => {
      this.initMap()
      // 新增点击事件监听
      this.map.on('click', this.handleMapClick)
      // 添加高亮图层
      this.initHighlightLayer()
      this.map.addLayer(this.highlightLayer)
      // 初始化详情页Overlay
      this.popup = new Overlay({
        element: document.getElementById('popup'),
        className: 'custom-popup', // 自定义样式类
      })
      this.map.addOverlay(this.popup)
      // 添加定时器，用于更新图层参数
      this.setupScaleDisplay()
      // 添加鼠标位置监听器
      this.setupMousePositionDisplay()
      // 加载区域名称标注（已停用：区域名称现由 GeoServer SLD 不渲染，OL 端也不再绘制）
      // this.loadAreaLabels()
    })
    this.queryAreaTree()
  },
  beforeDestroy() {
    // 清除定时器
    if (this.scaleDisplayInterval) {
      clearInterval(this.scaleDisplayInterval)
    }
  },
  created() {
    // 添加测试数据
  },
  methods: {
    initMap() {
      // 1. 投影配置 编码
      this.projection = getProjection(CONFIG.PROJECTION)
      // 从 WMTS 图层元数据中获取范围（假设服务端提供）
      let wmtsLayerExtent = CONFIG.DEFAULT_EXTENT

      // 图层组
      this.tileLayer = createLayerEm_topology_node_pipeline()
      this.tileSource = this.tileLayer.getSource()
      // 底图
      this.baseLayer = createLayerEM_MAP_ALL_18()
      // 点 图层
      this.nodeLayerNode = createLayerTp_node()
      // 线图层
      this.pipeLineLayer = createLayerTp_pipeline()
      // 区域图层
      this.areaLayer = createLayerTp_area()
      this.updateLayerParams(true)
      // 获取指定图层的范围
      // try {
      //   wmtsLayerExtent = getWMTSExtent('EM_MAP_ALL_18')
      //   console.log('图层范围:', extent) // [minX, minY, maxX, maxY]
      // } catch (error) {
      //   console.error('初始化失败，使用默认范围', error)
      //   // 降级方案
      //   wmtsLayerExtent = [83.533098, 46.42201, 83.910157, 46.588895]
      // }

      // 2. 动态计算中心点
      const center = [
        (wmtsLayerExtent[0] + wmtsLayerExtent[2]) / 2, // 经度平均值
        (wmtsLayerExtent[1] + wmtsLayerExtent[3]) / 2, // 纬度平均值
      ]

      // 3. 转换为投影坐标系
      const projectedCenter = fromLonLat(center)
      const projectedExtent = [
        ...fromLonLat([wmtsLayerExtent[0], wmtsLayerExtent[1]]),
        ...fromLonLat([wmtsLayerExtent[2], wmtsLayerExtent[3]]),
      ].flat()

      // 4. 创建视图
      this.view = new View({
        center: projectedCenter,
        zoom: 11,
        projection: this.projection,
        // extent: projectedExtent, // 动态设置视图范围
      })

      // 7. 创建地图实例
      this.map = new Map({
        target: 'map',
        layers: [this.baseLayer, this.areaLayer, this.pipeLineLayer, this.nodeLayerNode],
        view: this.view,
        // 添加比例尺控件
        controls: [
          new ScaleLine({
            className: 'ol-scale-line', // 自定义类名，用于样式覆盖
            units: 'metric', // 公制单位（米、公里）
            bar: false, // 使用条形比例尺（横向线段）
            steps: 1, // 比例尺分段数，这里设置为4段（默认是4，也可以不设置）
            text: false, // 显示比例尺文本
            minWidth: 80, // 最小宽度（像素）
            target: document.getElementById('scale-line-container'),
          }),
        ],
      })

      // +++ 新增：使用fit方法设置初始范围 +++
      this.$nextTick(() => {
        this.map.getView().fit(projectedExtent, {
          padding: [20, 20, 20, 20], // 添加适当的内边距
          duration: 0, // 立即生效
        })
      })
    },
    // 初始化高亮图层
    initHighlightLayer() {
      this.highlightLayer = new VectorLayer({
        source: new VectorSource(),
        style: feature => vectorStyle(feature), // 使用函数样式
        zIndex: 9999, // 确保在最上层
      })
    },
    /* ===== 区域名称标注（已停用）：原由 OpenLayers 通过 WFS 取 tp_area_sql 的 name 字段，
       用 ol/style/Text 绘制区域名称。现统一不在地图上显示区域名称，整块注释保留。
    // 加载区域名称标注
    async loadAreaLabels() {
      // 标注样式：所有区域名称始终显示，根据面积调整字号
      const styleFunction = (feature) => {
        const name = feature.get('name')
        if (!name) return null
        const area = feature.get('area') || 0
        // 根据面积调整字号
        let fontSize = 14
        if (area >= 500000) {
          fontSize = 14
        } else if (area >= 100000) {
          fontSize = 12
        } else {
          fontSize = 11
        }
        return new Style({
          text: new TextStyle({
            text: name,
            font: 'bold ' + fontSize + 'px sans-serif',
            fill: new Fill({ color: '#fff' }),
            stroke: new Stroke({ color: '#000', width: 3 }),
            offsetY: 0,
          }),
        })
      }
      // 创建标注图层
      this.areaLabelLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex: 100,
        style: styleFunction,
      })
      this.map.addLayer(this.areaLabelLayer)
      // 加载标注数据
      await this.refreshAreaLabels()
    },
    // 刷新区域标注
    async refreshAreaLabels() {
      if (!this.areaLabelLayer || !this.areaLabelLayer.getSource) return
      try {
        const wfsUrl = CONFIG.SERVICE_PATHS.WFS(CONFIG.WORKSPACE)
        const params = new URLSearchParams({
          service: 'WFS',
          version: '1.0.0',
          request: 'GetFeature',
          typeName: 'tp_data:tp_area_sql',
          outputFormat: 'application/json',
          srsName: 'EPSG:3857',
          viewParams: 'projectCode:' + CONFIG.TopologyProjection + ';topologyCode:' + CONFIG.TopologyCode,
        })
        const response = await fetch(wfsUrl + '?' + params.toString())
        const data = await response.json()
        const format = new GeoJSON()
        const features = format.readFeatures(data, {
          dataProjection: 'EPSG:3857',
          featureProjection: 'EPSG:3857',
        })
        const source = this.areaLabelLayer.getSource()
        source.clear()
        features.forEach((f) => {
          const geom = f.getGeometry()
          if (!geom) return
          const name = f.get('name')
          if (!name) return
          // 计算面积用于缩放级别控制
          let area = 0
          if (geom.getType() === 'Polygon') {
            area = geom.getArea()
          } else if (geom.getType() === 'MultiPolygon') {
            geom.getPolygons().forEach(p => { area += p.getArea() })
          }
          let labelPoint
          if (geom.getType() === 'Polygon') {
            const coords = geom.getInteriorPoint().getCoordinates()
            labelPoint = new Point([coords[0], coords[1]])
          } else if (geom.getType() === 'MultiPolygon') {
            const polygons = geom.getPolygons()
            let maxArea = 0
            let maxPoly = polygons[0]
            polygons.forEach(p => {
              const a = p.getArea()
              if (a > maxArea) {
                maxArea = a
                maxPoly = p
              }
            })
            if (maxPoly) {
              const coords = maxPoly.getInteriorPoint().getCoordinates()
              labelPoint = new Point([coords[0], coords[1]])
            }
          }
          if (!labelPoint) {
            const extent = geom.getExtent()
            labelPoint = new Point([(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2])
          }
          const labelFeature = new Feature({
            geometry: labelPoint,
            name: name,
            area: area,
          })
          source.addFeature(labelFeature)
        })
      } catch (error) {
        console.error('加载区域标注失败:', error)
      }
    },
    ===== 区域名称标注（已停用）结束 ===== */
    // 设置鼠标位置显示
    setupMousePositionDisplay() {
      this.mouseMoveListener = this.map.on('pointermove', event => {
        const coordinate = event.coordinate
        this.currentCoordinate = {
          x: coordinate[0],
          y: coordinate[1],
        }
      })
    },
    // 切换坐标系
    toggleCoordinateProjection() {
      this.coordinateProjection = this.coordinateProjection === 'EPSG:3857' ? 'EPSG:4326' : 'EPSG:3857'
    },
    // 点击事件 获取点 线 信息
    async handleMapClick(evt) {
      let that = this
      const coordinate = evt.coordinate
      console.log('点击左键evt属性:', coordinate)
      const view = this.map.getView()
      const resolution = view.getResolution()
      const projection = view.getProjection()

      // 2. 如果没获取到矢量要素，改用WMS GetFeatureInfo查询
      try {
        const layers = [
          { layer: this.nodeLayerNode, name: 'tp_node_sql' },
          { layer: this.pipeLineLayer, name: 'tp_pipeline_sql' },
          { layer: this.areaLayer, name: 'tp_area_sql' },
        ]
        // 查询点击信息
        const results = await Promise.all(
          layers.map(async layerInfo => {
            const info = await createGetFeatureInfo({
              map: this.map,
              coordinate,
              layer: layerInfo.layer,
              layerName: layerInfo.name,
              resolution,
              projection,
            })
            return { ...layerInfo, info }
          })
        )
        console.log('查询结果:', results)
        // 展示详情弹窗
        if (results[0].info.features.length > 0) {
          that.clickCurrentRow = Object.assign({}, results[0].info.features[0].properties, {
            id: results[0].info.features[0].id,
          })
          console.log('详情数据:', that.clickCurrentRow)
          // 重置IoT数据
          this.deviceData = null
          this.iotData = null
          // 显示详情
          this.popup.setPosition(coordinate)
          that.visible = true
          // 获取当前code详情
          let item = await this.getNodeInfo(that.clickCurrentRow.code)
          // 高亮
          this.parseAndHighLight(item)
          // 获取IoT物联数据
          this.loadIotData(that.clickCurrentRow.code)
        } else if (results[1].info.features.length > 0) {
          that.clickCurrentRow = Object.assign({}, results[1].info.features[0].properties, {
            id: results[1].info.features[0].id,
          })
          // 显示详情
          this.popup.setPosition(coordinate)
          that.visible = true
          // 获取当前code详情
          let item = await this.getLineInfo(that.clickCurrentRow.code)
          // 高亮
          this.parseAndHighLight(item)
        } else if (results[2].info.features.length > 0) {
          that.clickCurrentRow = Object.assign({}, results[2].info.features[0].properties)
          // this.popup.setPosition(coordinate)
          // that.visible = true
          let item = await this.getAreaInfo(that.clickCurrentRow.id)
          this.handleListClick(item)
        } else {
          // 关闭Overlay
          this.popup.setPosition(undefined)
          this.visible = false
          // 重置IoT数据
          this.deviceData = null
          this.iotData = null
          // 清除之前的高亮要素
          const highlightSource = this.highlightLayer.getSource()
          highlightSource.clear()
        }
        console.log('打印看看是啥数据', that.clickCurrentRow)

        // 处理所有图层的结果
        results.forEach(result => {
          if (result.info && result.info.features.length > 0) {
            console.log(`${result.name} 图层属性:`, result.info.features)
            result.info.features.forEach(feature => {
              console.log('详细属性:', feature.properties)
            })
          }
        })
      } catch (error) {
        console.error('WMS查询失败:', error)
      }
    },
    async getNodeInfo(code) {
      if (code == null) return null
      let parm = {
        projectCode: CONFIG.TopologyProjection,
        topologyCode: CONFIG.TopologyCode,
        code: code,
        name: null,
      }
      try {
        const res = await getPostGreSqlNodeInfoByCode(parm)
        if (res.success) {
          console.log('当前线信息', res.result)
          return res.result
        } else {
          return null
        }
      } catch (error) {
        console.error('获取线信息失败:', error)
        return null
      }
    },
    async getLineInfo(code) {
      if (code == null) return null
      let parm = {
        projectCode: CONFIG.TopologyProjection,
        topologyCode: CONFIG.TopologyCode,
        code: code,
        name: null,
      }
      try {
        const res = await getPostGreSqlLineInfoByCode(parm)
        if (res.success) {
          console.log('当前线信息', res.result)
          return res.result
        } else {
          return null
        }
      } catch (error) {
        console.error('获取线信息失败:', error)
        return null
      }
    },
    async getAreaInfo(code) {
      if (code == null) return null
      try {
        const res = await getPostGreSqlAreaInfoByCode(code)
        if (res.success) {
          return res.result
        } else {
          return null
        }
      } catch (error) {
        return null
      }
    },
    parseAndHighLight(item) {
      if (item == null) return
      // 解析十六进制geometry坐标。
      const geometry = parseHexWKB(item.geometry, 'EPSG:3857', 'EPSG:3857')
      if (!geometry) return

      // 清除之前的高亮要素
      const highlightSource = this.highlightLayer.getSource()
      highlightSource.clear()

      // 创建新要素并添加到高亮图层
      const feature = new Feature({
        geometry: geometry,
        featureType: item.id.startsWith('line') ? 'line' : 'point', // 标识类型
      })
      highlightSource.addFeature(feature)
      return geometry
    },
    async handleListClick(item) {
      if (!this.map) return
      const view = this.map.getView()

      // 解析十六进制geometry坐标。
      const geometry = this.parseAndHighLight(item)

      // 根据几何类型定位
      const geomType = geometry.getType()

      if (geomType === 'Point') {
        const coordinate = geometry.getCoordinates()
        await zoomToPoint(coordinate, view)
        // 设置弹窗位置
        this.clickCurrentRow = item
        this.popup.setPosition(coordinate)
        this.visible = true
      } else if (geomType === 'MultiLineString') {
        // 修复点1: 计算线要素的实际中心点
        const extent = geometry.getExtent()
        const center = [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2]

        // 修复点2: 等待缩放动画完成
        await zoomToLine(geometry, view)

        // 修复点3: 使用计算出的中心点设置弹窗
        this.clickCurrentRow = item
        this.popup.setPosition(center)
        this.visible = true
      } else if (geomType === 'MultiPolygon') {
        // 修复点1: 计算线要素的实际中心点
        const extent = geometry.getExtent()
        const center = [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2]

        // 修复点2: 等待缩放动画完成
        await zoomToLine(geometry, view)

        // 修复点3: 使用计算出的中心点设置弹窗
        this.clickCurrentRow = item
        // 区域显示右侧详情
        // this.popup.setPosition(center)
        // this.visible = true
      } else {
        this.closePopup()
      }
    },
    closePopup() {
      this.popup.setPosition(undefined)
      this.visible = false
      // 重置IoT数据
      this.deviceData = null
      this.iotData = null
      // 清除之前的高亮要素
      const highlightSource = this.highlightLayer.getSource()
      highlightSource.clear()
    },
    // 获取节点物联数据
    async loadIotData(code) {
      try {
        const res = await postAction('/jeecg-gis/topology/node/getNodeByCode', {
          code, projectCode: CONFIG.TopologyProjection,
          topologyCode: CONFIG.TopologyCode,
        })
        if (res.success && res.result) {
          this.deviceData = res.result.deviceData || null
          this.iotData = res.result.iotData || null
        }
      } catch (e) {
        console.warn('[loadIotData] 获取物联数据失败:', e)
      }
    },
    // +++ 新增：设置比例尺显示和参数更新 +++
    setupScaleDisplay() {
      // 初始化缩放层级
      this.updateZoomLevel()

      // 添加地图缩放监听
      this.map.getView().on('change:resolution', () => {
        this.updateZoomLevel()
      })
      // 定期更新图层参数
      this.scaleDisplayInterval = setInterval(() => {
        this.updateLayerParams(false)
      }, 500)
    },
    // +++ 新增：更新缩放层级 +++
    updateZoomLevel() {
      if (this.map && this.map.getView()) {
        const currentZoom = this.map.getView().getZoom()
        // 四舍五入到整数（如果需要小数可以去掉）
        this.zoomLevel = Math.round(currentZoom)
      }
    },
    // 更新所有图层的参数
    updateLayerParams(tickTime) {
      // 更新拓扑参数（如果缓存有变化）
      // 更新所有图层的参数
      const layers = [this.nodeLayerNode, this.pipeLineLayer, this.areaLayer]
      if (tickTime) {
        layers.forEach(layer => {
          if (layer && layer.getSource && layer.getSource().updateParams) {
            layer.getSource().updateParams({
              VIEWPARAMS:
                'projectCode:' +
                CONFIG.TopologyProjection +
                ';topologyCode:' +
                CONFIG.TopologyCode +
                ';zoomLevel:' +
                this.zoomLevel,
              t: Date.now(), // 防止缓存
            })
            // 强制刷新图层（解决缓存问题）
            layer.getSource().refresh()
          }
        })
      } else {
        layers.forEach(layer => {
          if (layer && layer.getSource()) {
            layer.getSource().updateParams({
              VIEWPARAMS:
                'projectCode:' +
                CONFIG.TopologyProjection +
                ';topologyCode:' +
                CONFIG.TopologyCode +
                ';zoomLevel:' +
                this.zoomLevel,
            })

            // 强制刷新图层（解决缓存问题）
            layer.getSource().refresh()
          }
        })
      }
    },
    refreshPipelineLayer() {
      const source = this.pipeLineLayer.getSource()
      source.updateParams({
        STYLES: 'Dynamic_Pipeline_Style',
        t: Date.now(), // 防止缓存
      })
      this.$nextTick(() => {
        this.map.updateSize()
      })
    },
    testPoint() {
      updateOrCreateGeoServerStyle().then(() => { })
    },
    changeMap() {
      this.areaLayer.getSource().updateParams({
        _t: new Date().getTime(),
      })
      this.areaLayer.getSource().refresh()
      this.closePopup()
    },
    handleLocation(item) {
      console.log('列表点击', item)
      this.handleListClick(item)
    },
    // 新增分区/关闭新增
    handleOpenOrClose() {
      this.isAddOpen = !this.isAddOpen
      if (this.isAddOpen) {
        // 新增
        this.mode = 'addArea'
        this.changeMap1()
      } else {
        // 关闭
        if (this.drawInteraction) {
          this.map.removeInteraction(this.drawInteraction)
          this.drawInteraction = null
        }
        // 清除矢量数据源
        this.areaVectorSource.clear()
        // 更新图层
        this.updateLayerParams(true)
        // 更新树数据
        this.queryAreaTree()
      }
    },
    changeMap1() {
      // 创建区域矢量图层
      const areaVectorLayer = new VectorLayer({
        source: this.areaVectorSource,
        style: new Style({
          fill: new Fill({ color: 'rgba(255, 255, 255, 0.4)' }),
          stroke: new Stroke({
            radius: 7,
            color: '#ffcc33',
            width: 2,
            fill: '#ffcc33',
          }),
        }),
      })
      // 将矢量图层添加到地图中
      this.map.addLayer(areaVectorLayer)

      this.modifyInteraction = new Modify({
        source: this.areaVectorSource,
      })
      this.map.addInteraction(this.modifyInteraction)
      this.modifyInteraction.setActive(false)
      this.pipeSnapInteraction = this.modifyInteraction
      this.changeMode()
    },
    changeMode() {
      // 清除当前的绘制交互
      if (this.drawInteraction) {
        this.map.removeInteraction(this.drawInteraction)
        this.drawInteraction = null
      }
      switch (this.mode) {
        case 'none':
          this.modifyInteraction.setActive(false)
          this.pipeSnapInteraction.setActive(false)
          break
        case 'addArea':
          this.modifyInteraction.setActive(false)
          this.pipeSnapInteraction.setActive(true)
          this.drawInteraction = new Draw({
            source: this.areaVectorSource,
            type: 'Polygon',
          })
          this.drawInteraction.on('drawend', event => {
            const geometry = event.feature.getGeometry()
            let pointArr = geometry.getCoordinates()
            this.model.geometry = this.generateWKT(pointArr)
            this.model.projectCode = CONFIG.TopologyProjection
            this.model.topologyCode = CONFIG.TopologyCode
            this.visibleModal = true
            // 绘制结束打开添加区域的模态框
          })
          this.map.addInteraction(this.drawInteraction)
          break
      }
    },
    generateWKT(coordinates) {
      // 生成WKT字符串
      let arr = []
      coordinates.map((coord, index) => {
        coord.map(item => {
          arr.push(`${item[0]} ${item[1]} 0`)
        })
      })
      const points = arr.join(',')
      return `POLYGON((${points}))`
    },
    // enerateWKBHex(data) {
    //   // 将坐标数组转换为WKB十六进制字符串
    //   const coords = data

    //   // 创建字节数组
    //   const wkb = new ArrayBuffer(1 + 4 + 4 + 4 + 4 * 16)
    //   const view = new DataView(wkb)

    //   // 设置字节序 (小端)
    //   view.setUint8(0, 1)

    //   // 设置几何类型 (多边形)
    //   view.setUint32(1, 3, true)

    //   // 设置环数 (1)
    //   view.setUint32(5, 1, true)

    //   // 设置点数 (4)
    //   view.setUint32(9, 4, true)

    //   // 添加坐标点
    //   let offset = 13
    //   for (let i = 0; i < coords.length; i++) {
    //     view.setFloat64(offset, coords[i][0], true)
    //     offset += 8
    //     view.setFloat64(offset, coords[i][1], true)
    //     offset += 8
    //   }

    //   // 转换为十六进制字符串
    //   const hexArray = []
    //   const uint8 = new Uint8Array(wkb)
    //   for (let i = 0; i < uint8.length; i++) {
    //     const hex = uint8[i].toString(16).padStart(2, '0')
    //     hexArray.push(hex)
    //   }

    //   return hexArray.join('').toUpperCase()
    // },
    handleOk() {
      const that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          this.model.showFlag = 1
          this.model.areaLevel = 1
          this.model.parentCode = ''
          if (this.addAreaType == 'addSub') {
            this.model.parentCode = this.currSelected.code
          }
          postAction(this.url.add, this.model)
            .then(res => {
              if (res.success) {
                that.$message.success(this.$t('新增分区成功！'))
                that.visibleModal = false
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              // 关闭分区编辑页
              that.handleOpenOrClose()
            })
        }
      })
    },
    handleCancel() {
      this.visibleModal = false
      this.model = {}
      // 关闭分区编辑页
      this.handleOpenOrClose()
    },
    // 获取分区树
    queryAreaTree() {
      let params = {
        projectCode: CONFIG.TopologyProjection,
        topologyCode: CONFIG.TopologyCode,
      }
      postAction(this.url.queryAreaTree, params).then(res => {
        if (res.success) {
          this.areaTree = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    nodeClick(record, node, data) {
      if (node.checked) {
        this.currentNodeKey = record.code
        this.$refs.areaTree.setCheckedKeys([record.code])
        this.currSelected = Object.assign({}, record)
      } else {
        this.currentNodeKey = null
        this.currSelected = {}
        this.$refs.areaTree.setCheckedKeys([])
      }
    },
    resetAareaData() {
      console.log('@unselect=resetAareaData')
      this.areaDetailVisible = false
      this.areaInfo = {}
      this.areaNodeList = []

      this.hiding = true
      this.checkedKeys = []
      this.currSelected = {}
      this.selectedKeys = []
      if (this.rootOpened) {
        this.setThisExpandedKeys(this.areaTree)

        // 20220228修改的
        this.currentNodeKey = null
        if (this.$refs.areaTree) {
          this.$refs.areaTree.setCheckedKeys([])
        }
      }
    },
    unselect() {
      this.resetAareaData()
    },
    setThisExpandedKeys(arr) {
      if (arr && arr.length > 0) {
        let keys = []
        for (let item of arr) {
          if (item.children && item.children.length > 0) {
            keys.push(item.code)
          }
        }
        this.iExpandedKeys = [...keys]
      } else {
        this.iExpandedKeys = []
      }
    },
    // 新增一级分区
    handleAreaAdd() {
      console.log('新增主分区')
      this.addAreaType = 'addMain'
      this.isAddOpen = true
      this.mode = 'addArea'
      this.model = {}
      this.changeMap1()
    },
    // 新增所选分区的子分区
    handleAdd(node, data) {
      console.log('添加子级分区')
      console.log('node', node)
      console.log('data', data)
      this.addAreaType = 'addSub'
      this.isAddOpen = true
      this.mode = 'addArea'
      this.model = {}
      this.changeMap1()
    },
    // 删除所选分区
    handleDelete(node, data) {
      let that = this
      console.log('删除分区')
      console.log('node', node)
      console.log('data', data)
      let params = { id: data.id }
      deleteAction(this.url.deleteArea, params).then(res => {
        if (res.success) {
          that.$message.success(this.$t('删除分区成功！'))
        } else {
          that.$message.warning(res.message)
        }
        // 取消分区树选择
        this.currSelected = {}
        // 更新图层
        that.updateLayerParams(true)
        // 更新树数据
        that.queryAreaTree()
      })
    },
    // 处理树形组件事件
    handleTreeToggle(visible) {
      this.collapsed = !visible
    },
    handleNodeUnselected() {
      console.log('节点取消选中')
      this.currSelected = {}
      this.currentNodeKey = null
    },

    collapseTree() {
      // 实现折叠所有节点的逻辑
      if (this.$refs.areaTreeCard.$refs.areaTree) {
        const treeRef = this.$refs.areaTreeCard.$refs.areaTree
        const allNodes = treeRef.store._getAllNodes()
        allNodes.forEach(node => {
          node.expanded = false
        })
      }
    },
    // 处理树节点选中事件
    async handleNodeSelected(record) {
      console.log('节点选中', record)
      this.currSelected = record
      this.currentNodeKey = record.code
      this.handleListClick(record)
      // 显示详情组件
      this.areaDetailVisible = true

      try {
        this.detailLoading = true

        // 1. 获取区域详情
        const detailRes = await this.getAreaDetail(record.id)
        if (detailRes && detailRes.success) {
          this.areaInfo = detailRes.result
        }

        // 2. 获取区域节点列表
        const nodeRes = await this.getAreaNodeList(record)
        if (nodeRes && nodeRes.success) {
          this.areaNodeList = nodeRes.result
        }
      } catch (error) {
        console.error('获取区域详情失败:', error)
        this.$message.error(this.$t('获取区域详情失败'))
      } finally {
        this.detailLoading = false
      }
    },

    // 获取区域详情接口
    getAreaDetail(id) {
      let params = { id: id }
      return getAction('/jeecg-gis/area/queryById', params)
    },

    // 获取区域节点列表接口
    getAreaNodeList(record) {
      let params = {
        projectCode: CONFIG.TopologyProjection,
        topologyCode: CONFIG.TopologyCode,
        areaCode: record.code,
        searchValue: '',
      }
      return postAction('/jeecg-gis/area/queryNodeByArea', params)
    },
    // 显示节点选择弹窗
    async showNodeModal() {
      try {
        const res = await this.fetchAllNodes()
        if (res && res.success) {
          this.allNodes = res.result.records || []
          this.pagination.total = res.result.total || 0
        }
        this.nodeModalVisible = true
        this.selectedNodeKeys = []
      } catch (error) {
        console.error('获取所有节点失败:', error)
      }
    },

    // 获取所有节点
    fetchAllNodes(params = {}) {
      return getAction('/jeecg-gis/topology/node/list', {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        areaId: ''
      })
    },

    // 处理表格翻页
    handleTableChange(pagination) {
      this.pagination = pagination
      this.fetchAllNodes({
        pageNo: pagination.current,
        pageSize: pagination.pageSize,
      })
    },

    // 处理节点选择
    handleNodeSelection(selectedKeys) {
      this.selectedNodeKeys = selectedKeys
    },

    // 添加节点到区域
    async handleAddNodes() {
      if (!this.selectedNodeKeys.length) {
        this.$message.warning(this.$t('请选择要添加的节点'))
        return
      }

      try {
        const res = await postAction('/jeecg-gis/area/addNodes', {
          areaId: this.currSelected.id,
          nodeIds: this.selectedNodeKeys,
        })

        if (res.success) {
          this.$message.success(this.$t('添加节点成功'))
          // 刷新节点列表
          const nodeRes = await this.getAreaNodeList(this.currSelected.id)
          if (nodeRes && nodeRes.success) {
            this.areaNodeList = nodeRes.result
          }
          this.nodeModalVisible = false
        } else {
          this.$message.error(res.message || this.$t('添加节点失败'))
        }
      } catch (error) {
        console.error('添加节点失败:', error)
        this.$message.error(this.$t('添加节点失败'))
      }
    },

    // 删除区域节点
    async handleDeleteNode(nodeId) {
      try {
        const res = await postAction('/jeecg-gis/topology/node/unbindArea?id='+nodeId)

        if (res.success) {
          this.$message.success(this.$t('删除节点成功'))
          // 重新加载节点列表
          const nodeRes = await this.getAreaNodeList(this.currSelected.id)
          if (nodeRes && nodeRes.success) {
            this.areaNodeList = nodeRes.result
          }
        } else {
          this.$message.error(res.message || this.$t('删除节点失败'))
        }
      } catch (error) {
        console.error('删除节点失败:', error)
        this.$message.error(this.$t('删除节点失败'))
      }
    },
    handleCloseAreaDetail() {
      this.areaDetailVisible = false
      // 也可以选择清除选中状态
      this.currSelected = {}
      this.$refs.areaTreeCard.unselect()
    },
  },
}
</script>

<style scoped lang="less">
#map {
  width: 100%;
  height: 80vh;
  position: relative;
}

#popup {
  background: rgba(70, 76, 92, 0.8);
  /* Components2的半透明白色背景 */
  border-radius: 6px;
  color: white;
  width: 200px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);

  .popup-header {
    display: flex;
    justify-content: space-between;
    padding: 8px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);

    .anticon-close {
      cursor: pointer;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .popup-list {
    max-height: 300px;
    overflow-y: auto;

    .ant-list-item {
      color: white;
      border-color: rgba(255, 255, 255, 0.2);
      padding: 8px 12px;
    }
  }

  .popup-iot-divider {
    color: #1890ff;
    font-weight: bold;
    padding: 8px 12px 4px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }

  .popup-iot-empty {
    color: rgba(255, 255, 255, 0.5);
    padding: 8px 12px;
    text-align: center;
    font-size: 12px;
  }
}

/* +++ 新增比例尺样式 +++ */
/* 自定义比例尺控件样式 */
.ol-scale-line {
  background: rgba(255, 255, 255, 0.5);
  /* 半透明白色背景 */
  border-radius: 4px;
  bottom: 8px;
  left: 8px;
  /* 默认在左下角，可以调整位置 */
  padding: 2px;
  position: absolute;
}

.ol-scale-line-inner {
  border: 1px solid #333;
  border-top: none;
  color: #333;
  font-size: 12px;
  text-align: center;
  margin: 1px;
  will-change: contents, width;
  transition: all 0.25s;
  /* 禁止用户选择文本 */
  user-select: none;
  pointer-events: none;
}

/* 如果想要将比例尺放在右下角，可以这样调整 */
.ol-scale-line {
  left: auto;
  right: 8px;
}

/* 右下角控制信息容器 */
.map-controls-container {
  position: absolute;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 2;
  gap: 5px;
}

/* 缩放级别显示 */
.zoom-level-display {
  background: rgba(255, 255, 255, 0.5);
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  color: #333;
  font-weight: normal;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  user-select: none;
  margin-bottom: 13px;
}

/* 坐标显示 - 可点击切换 */
.coordinate-display {
  background: rgba(255, 255, 255, 0.5);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  color: #333;
  font-weight: bold;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  text-align: center;
  transition: all 0.3s;
  user-select: none;

  /* 等宽字体确保对齐 */
  font-family: 'Courier New', Courier, monospace;

  /* 在可点击元素上添加悬停效果 */
  &:hover {
    background: rgba(245, 245, 245, 0.95);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  }

  /* 添加坐标系提示 */
  .projection-hint {
    font-size: 10px;
    color: #666;
    margin-top: 2px;
    font-weight: normal;
    font-style: italic;
  }
}

/* 自定义比例尺容器 */
.scale-line-custom-container {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  padding: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.scale-line-custom-container .ol-scale-line {
  margin-bottom: 24px;
}

/* 比例尺样式 */
.scale-line-custom .ol-scale-line {
  position: static;
  background: none;
}

/* 比例尺文本 */
.scale-line-custom .ol-scale-text {
  font-size: 11px;
  font-weight: bold;
  color: #333;
  text-shadow: 0 0 2px white;
  text-align: center;
  margin-top: 2px;
}

/* 比例尺条 */
.scale-line-custom .ol-scale-bar {
  background: #333;
  height: 3px;
  margin-top: 2px;
}

.map-add-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
}

.area-detail-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 90%;
  background: rgba(31, 31, 31, 0.8);
  border-radius: 6px;
  padding: 15px;
  z-index: 999;
  overflow-y: auto;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.5);
}

.detail-header {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #444;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.detail-form {
  margin-bottom: 20px;
}

.form-item {
  color: #ddd;
  margin-bottom: 10px;
}

.form-label {
  display: inline-block;
  width: 70px;
  color: #aaa;
}

.form-value {
  color: #fff;
}

.node-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.node-list-title {
  color: #fff;
  font-weight: bold;
}

.add-node-btn {
  background: #1890ff;
  border-color: #1890ff;
}

::v-deep .ant-table {
  background: transparent;
}

::v-deep .ant-table-thead>tr>th {
  background: #2a2a2a;
  color: #aaa;
  border-bottom: 1px solid #444;
}

::v-deep .ant-table-tbody>tr>td {
  background: #1f1f1f;
  color: #ddd;
  border-bottom: 1px solid #444;
}

::v-deep .ant-table-row:hover>td {
  background: #333 !important;
}
</style>
